export enum BillingPlanGroup {
    Starter = 'starter',
    Pro = 'pro',
    Scale = 'scale',
}
